var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingSection2Img(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-double-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77838 11.2159C3.10788 10.8864 3.64212 10.8864 3.97162 11.2159L13.5 20.7443L23.0284 11.2159C23.3579 10.8864 23.8921 10.8864 24.2216 11.2159C24.5511 11.5454 24.5511 12.0796 24.2216 12.4091L14.0966 22.5341C13.7671 22.8636 13.2329 22.8636 12.9034 22.5341L2.77838 12.4091C2.44887 12.0796 2.44887 11.5454 2.77838 11.2159Z",
    fill: "#42D09F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77838 4.46588C3.10788 4.13637 3.64212 4.13637 3.97162 4.46588L13.5 13.9943L23.0284 4.46588C23.3579 4.13637 23.8921 4.13637 24.2216 4.46588C24.5511 4.79538 24.5511 5.32962 24.2216 5.65912L14.0966 15.7841C13.7671 16.1136 13.2329 16.1136 12.9034 15.7841L2.77838 5.65912C2.44887 5.32962 2.44887 4.79538 2.77838 4.46588Z",
    fill: "#42D09F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingSection2Img);
export default __webpack_public_path__ + "static/media/LandingSection2Img.335c13c85c995a85fad7f867d3b2353c.svg";
export { ForwardRef as ReactComponent };